import FwOpsReportHalfRebuild from 'pared/aiBlackbox/expo/FwOpsReportHalfRebuild'
import TableExample from 'pared/aiBlackbox/expo/TableExample'

import { IAiBlackboxProps } from '../type'

export default function getExpoContent(
  contentPartName: string,
): React.FC<IAiBlackboxProps> | null {
  switch (contentPartName) {
    case 'expoTableExample':
      return TableExample
    case 'expoFwOpsReportHalfRebuild':
      return FwOpsReportHalfRebuild
    default:
      return null
  }
}
